import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './slices/authSlice';
import menuReducer from './slices/menuSlice';
import leadsReducer from './slices/leadsSlice';
import searchReducer from './slices/searchSlice';
import proposalsReducer from './slices/proposalsSlice';
import projectsReducer from './slices/projectsSlice';
import changeOrdersReducer from './slices/changeOrdersSlice';
import projectProposalsReducer from './slices/projectProposalsSlice';
import settingsReducer from './slices/settingsSlice';
import rolesReducer from './slices/rolesSlice';
import eventsReducer from './slices/eventsSlice';
import calendarsReducer from './slices/calendarsSlice';
import crewsReducer from './slices/crewsSlice';
import tradesReducer from './slices/tradesSlice';
import peopleReducer from './slices/peopleSlice';
import usersReducer from './slices/usersSlice';
import safetyReducer from './slices/safetySlice';
import clientsReducer from './slices/clientsSlice';
import citiesReducer from './slices/citiesSlice';
import projectDocumentsReducer from './slices/projectDocumentsSlice';
import viewReducer from './slices/viewSlice';
import loadingReducer from './slices/loadingSlice';
import financialReducer from './slices/financialSlice';
import projectPermitsReducer from './slices/projectPermitsSlice';
import notificationsReducer from './slices/notificationsSlice';
import { loadingMiddleware } from './middleware/loadingMiddleware';

// Separate configs for auth and menu
const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['user', 'token', 'isAuthenticated'],
  transforms: [
    {
      in: (state) => state,
      out: (state, key) => {
        if (state && !state.isAuthenticated) {
          return undefined;
        }
        return state;
      }
    }
  ]
};

const menuPersistConfig = {
  key: 'menu',
  storage,
  whitelist: ['activeMenuItem', 'activeSubmenuItem', 'activeSection', 'showGreyMenu']
};

const viewPersistConfig = {
  key: 'view',
  storage,
  whitelist: ['viewMode', 'viewPreferences']
};

const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);
const persistedMenuReducer = persistReducer(menuPersistConfig, menuReducer);
const persistedViewReducer = persistReducer(viewPersistConfig, viewReducer);

export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    menu: persistedMenuReducer,
    leads: leadsReducer,
    search: searchReducer,
    proposals: proposalsReducer,
    projects: projectsReducer,
    changeOrders: changeOrdersReducer,
    projectProposals: projectProposalsReducer,
    settings: settingsReducer,
    roles: rolesReducer,
    users: usersReducer,
    events: eventsReducer,
    calendars: calendarsReducer,
    crews: crewsReducer,
    trades: tradesReducer,
    people: peopleReducer,
    safety: safetyReducer,
    clients: clientsReducer,
    cities: citiesReducer,
    projectDocuments: projectDocumentsReducer,
    financial: financialReducer,
    view: persistedViewReducer,
    loading: loadingReducer,
    projectPermits: projectPermitsReducer,
    notifications: notificationsReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/REGISTER'],
      },
    }).concat(loadingMiddleware),
});

export const persistor = persistStore(store); 